module.exports = __webpack_public_path__ + "img/hand.30b9540a.svg";